<template>
  <b-container
    fluid
    class="min-vh-100 d-flex align-items-center justify-content-center bg-light"
  >
    <b-card class="shadow-sm text-center p-4" style="max-width: 560px">
      <div class="mb-3">
        <i class="icofont-ban text-danger" style="font-size: 42px"></i>
      </div>

      <h2 class="mb-2">{{ title }}</h2>
      <p class="text-muted mb-3">{{ description }}</p>

      <b-alert v-if="reason" show variant="warning" class="text-left mb-3">
        <strong>Motivo:</strong> {{ reason }}
      </b-alert>

      <slot name="extra"></slot>

      <div class="d-flex flex-wrap justify-content-center mt-2">
        <b-button variant="outline-secondary" class="m-1" @click="goHome">
          Ir para o início
        </b-button>
      </div>

      <div v-if="support" class="mt-3 text-muted small">
        Precisa de ajuda? <a :href="`mailto:${support}`">{{ support }}</a>
      </div>
    </b-card>
  </b-container>
</template>

<script>
export default {
  name: 'PaginaIndisponivel',
  props: {
    title: {
      type: String,
      default: 'Página indisponível',
    },
    description: {
      type: String,
      default:
        'Você não tem permissão ou este conteúdo está temporariamente indisponível.',
    },
    reason: {
      type: String,
      default: '',
    },
    support: {
      type: String,
      default: '',
    },
  },
  methods: {
    goBack() {
      if (window.history.length > 1) this.$router.go(-1)
      else this.goHome()
    },
    goHome() {
      this.$store.dispatch('logout')
      this.$router.push('/login')
    },
    reload() {
      window.location.reload()
    },
  },
}
</script>

<style scoped>
.min-vh-100 {
  min-height: 100vh;
}
</style>
